<template>
  <span class="atom-input-checkbox" :class="`atom-input-checkbox--${color}`">
    <input type="checkbox" v-model="inputValue" :disabled="isDisabled" />
    <span class="atom-input-checkbox__checkbox">
      <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.0838 0L5.0425 6.67722C4.94325 6.78692 4.77098 6.78692 4.67173 6.67722L2.24939 3.9999H0.226562L3.55943 7.68359C4.25417 8.45146 5.46007 8.45146 6.1548 7.68359L13.1066 0H11.0838Z"
          fill="#00DBA6"
        />
      </svg>
    </span>
  </span>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

/**
 * チェックボックスを表示するAtomコンポーネント。
 */
export default defineComponent({
  name: 'AtomInputCheckbox',
  props: {
    /**
     * Value値
     */
    value: {
      type: Boolean,
      required: true,
    },
    /**
     * 非活性にするかどうか
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * カラーパターン
     */
    color: {
      type: String,
      default: 'light',
    },
  },
  setup(props, context) {
    /**
     * inputValue
     * @param {string} val チェックボックスの値
     */
    const inputValue = computed({
      get: () => props.value,
      set: (val: boolean) => context.emit('input', val),
    })

    return {
      inputValue,
    }
  },
})
</script>

<style lang="scss" scoped>
.atom-input-checkbox {
  &__checkbox {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 2px;

    svg {
      opacity: 0;
    }
  }

  [type='checkbox'] {
    &:checked + .atom-input-checkbox__checkbox {
      svg {
        opacity: 1;
      }
    }

    &:disabled + .atom-input-checkbox__checkbox {
      svg {
        opacity: 0;
      }
    }

    &:disabled:checked + .atom-input-checkbox__checkbox {
      svg {
        opacity: 1;
      }
    }
  }

  &--light {
    [type='checkbox'] {
      + .atom-input-checkbox__checkbox {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 20%);
      }

      &:checked + .atom-input-checkbox__checkbox {
        background: #1f1f1f;
        border: 1px solid rgba(0, 0, 0, 10%);
      }

      &:disabled + .atom-input-checkbox__checkbox {
        background: #e5e5e5;
        border: 1px solid rgba(0, 0, 0, 10%);
      }

      &:disabled:checked + .atom-input-checkbox__checkbox {
        background: #808080;
        border: 1px solid rgba(0, 0, 0, 5%);

        svg {
          path {
            fill: $gray25;
          }
        }
      }
    }
  }

  &--dark {
    [type='checkbox'] {
      + .atom-input-checkbox__checkbox {
        background: #2b2b2b;
        border: 1px solid $gray25;
      }

      &:checked + .atom-input-checkbox__checkbox {
        background: #00dba6;
        border: none;

        svg {
          path {
            fill: $black;
          }
        }
      }

      &:disabled + .atom-input-checkbox__checkbox {
        background: #2b2b2b;
        border: 1px solid $gray75;
      }

      &:disabled:checked + .atom-input-checkbox__checkbox {
        background: #808080;
        border: none;

        svg {
          path {
            fill: $gray75;
          }
        }
      }
    }
  }
}
</style>
